import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TokenStorageService } from './token-storage.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrl + 'academy-achievements';

@Injectable({
  providedIn: 'root'
})
export class AcademyHighlightService {
  authtoken: string;
  private httpOptions;
  constructor(private http: HttpClient, private token: TokenStorageService) {
    this.authtoken = this.token.getToken();
    this.httpOptions = {
      Headers: new HttpHeaders()
        .set("Content-Type", "application/json")
        .set('Authorization', `Bearer ${this.authtoken}`)
    };
  }
  getAcademyHighlightList(query): Observable<any> {
    return this.http.get(API_URL + query, this.httpOptions);
  }
  getAcademyHighlightDetails(id): Observable<any> {
    return this.http.get(API_URL + '/' + id, this.httpOptions);
  }
  updateAcademyHighlight(id, data): Observable<any> {
    console.log(id);
    
    return this.http.put(API_URL + '/' + id, data, this.httpOptions);
  }
  addAcademyHighlight(data): Observable<any> {
    return this.http.post(API_URL, data, this.httpOptions);
  }
}
